<script>
  import { t } from '../i18n/i18n'
  export let id
  export let label
  export let value
  export let type = 'text'
  export let valid = true
  export let validityMessage = ''
  export let staticMessage = ''
  export let required = null
  export let toggleVisible = false

  let touched = false

  const toggle = () => type === 'password' ? type = 'text' : type = 'password'

</script>

<style>
  input {
    display: block;
    width: 100%;
    font: inherit;
    border: 2px solid #ccc;
    background: #f7f7f7;
    padding: .15rem .5rem;
    border-radius: var(--radius);
    transition: border-color .1s ease-out;
  }

  input:focus {
    border-color: var(--green);
    outline: none;
  }

  label {
    display: block;
    width: 100%;
  }

  .form-control {
    padding: .5rem 0;
    width: 100%;
    margin: .25rem 0;
  }

  .invalid {
    border: 2px solid var(--red);
  }

  .static-message {
    font-size: 1.4rem;
    margin-bottom: 0;
  }

  .password, .showhide {
    display: flex;
    align-items: center;
  }

  .showhide label, .showhide input {
    font-size: 1.4rem;
    min-width: 3rem;
  }

</style>

<div class="form-control">
  <section class:password={toggleVisible}>
    <label for={id}>
      {label}
      {#if required}
        <span class='g-error'>*</span>
      {/if}
    </label>
    {#if toggleVisible} 
      <div class="showhide">
        <input type="checkbox" name="" id="toggle" on:click={toggle}>
        <label for="toggle">{type === 'password' ? $t.show : $t.hide}</label>
      </div>
    {/if}
  </section>
    <slot>
      <input {type} {id} {value} on:input class:invalid={!valid && touched} on:blur={() => touched = true}/>
    </slot>
  {#if staticMessage}
    <p class="static-message">{staticMessage}</p>
  {/if}
  {#if validityMessage && !valid && touched} 
    <span class="g-error">{validityMessage}</span>
  {/if}
</div>
